<template>
  <div class="about-page">
    <!-- banner -->
    <div class="banner" v-if="!isMobile"></div>
    <img v-else class="mobile-banner" :src="assets.banner" alt="banner" />
    <!-- 股东介绍 -->
    <!-- 百度推广要求不能出现具体引导信息 -->
    <div class="view-section shareholder-wrapper" v-if="false">
      <div class="view-width">
        <section-header
          :main-title="'股东介绍'"
          :sub-title="'Introduction to shareholders'"
          :align="'left'"
        ></section-header>
        <el-row :gutter="20" class="description">
          <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16" class="info">
            <p>
              内蒙古庆源绿色金融资产管理有限公司于2017年12月26日成立，注册资本14亿元人民币。主营业务范围：
            </p>
            <p class="has-icon">收购、受托经营金融机构不良资产;</p>
            <p class="has-icon">债权转股权,对股权资产进行管理、投资和处置等;</p>
            <p>公司致力于信用修复，非金融机构低效无效资产业务创新解决方案。</p>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="cover">
            <img
              :src="require('@/assets/img/banner/advertisement5.png')"
              alt=""
            />
          </el-col>
        </el-row>
        <div class="description" v-if="false">
          <div class="info">
            <p>
              内蒙古庆源绿色金融资产管理有限公司于2017年12月26日成立，注册资本14亿元人民币。主营业务范围：
            </p>
            <p class="has-icon">收购、受托经营金融机构不良资产;</p>
            <p class="has-icon">债权转股权,对股权资产进行管理、投资和处置等;</p>
            <p>公司致力于信用修复，非金融机构低效无效资产业务创新解决方案。</p>
          </div>
          <div class="cover">
            <img
              :src="require('@/assets/img/banner/advertisement5.png')"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 公司介绍 -->
    <div class="view-section company-wrapper">
      <div class="view-width">
        <section-header
          :main-title="'公司介绍'"
          :sub-title="'Introduction to company'"
          :align="'left'"
        ></section-header>
        <div class="description">
          深圳市庆源绿色商业保理有限公司2017年6月15日于深圳市前海自贸
          区注册，主营范围：保付代理（非银行融资类）；从事担保业务（不
          含融资性担保业务）；信用风险管理软件的开发；与商业保理相关的
          咨询服务（不含限制项目）；投资兴办实业（具体项目另行申报）；
          投资咨询、经济信息咨询、财务信息咨询（以上均不含限制项目）；
          供应链管理；国内贸易、经营进出口业务（不含专营、专控、专卖商
          品）。公司致力于供应链票据下小微企业融资服务解决方案。
        </div>
        <div class="company-advantages">

          <ul class="lines line-1" v-if="true">
            <li
              class="item"
              v-for="(item, index) in companyAdvantages"
              :key="index"
            >
              <i class="icon">
                <img
                  :src="item.icon"
                  :alt="item.text"
                  :style="`height: ${item.height || '100%'}`"
                />
              </i>
              <p class="text">{{ item.text }}</p>
            </li>
          </ul>

          <el-row :gutter="20" class="lines line-1" v-if="false">
            <el-col
              :xs="12"
              :sm="12"
              :md="6"
              :lg="6"
              :xl="6"
              class="item"
              v-for="(item, index) in companyAdvantages"
              :key="index"
            >
              <i class="icon">
                <img
                  :src="item.icon"
                  :alt="item.text"
                  :style="`height: ${item.height || '100%'}`"
                />
              </i>
              <p class="text">{{ item.text }}</p>
            </el-col>
          </el-row>
          <ul class="lines line-1" v-if="false">
            <li
              class="item"
              v-for="(item, index) in companyAdvantages"
              :key="index"
            >
              <i class="icon">
                <img
                  :src="item.icon"
                  :alt="item.text"
                  :style="`height: ${item.height || '100%'}`"
                />
              </i>
              <p class="text">{{ item.text }}</p>
            </li>
          </ul>
          <ul class="lines line-2">
            <li
              class="item"
              v-for="(item, index) in companyAdvantages1"
              :key="index"
            >
              <i class="icon">
                <img
                  :src="item.icon"
                  :alt="item.text"
                  :style="`height: ${item.height || '100%'}`"
                />
              </i>
              <p class="text">{{ item.text }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      assets: {
        banner: require("@/assets/img/banner/banner6.png")
      },
      companyAdvantages: [
        {
          icon: require("@/assets/img/icons/finance_1.png"),
          text: "保付代理"
        },
        {
          icon: require("@/assets/img/icons/finance_2.png"),
          text: "担保业务"
        },
        {
          icon: require("@/assets/img/icons/finance_3.png"),
          text: "信用风险管理软件的开发",
          height: "65%"
        },
        {
          icon: require("@/assets/img/icons/finance_4.png"),
          text: "商业保理相关的咨询服务",
          height: "65%"
        }
      ],
      companyAdvantages1: [
        {
          icon: require("@/assets/img/icons/finance_5.png"),
          text: "投资兴办实业"
        },
        {
          icon: require("@/assets/img/icons/finance_6.png"),
          text: "投资、经济信息咨询"
        },
        {
          icon: require("@/assets/img/icons/finance_7.png"),
          text: "财务信息咨询",
          height: "65%"
        },
        {
          icon: require("@/assets/img/icons/finance_8.png"),
          text: "供应链管理"
        },
        {
          icon: require("@/assets/img/icons/finance_9.png"),
          text: "国内贸易、经营进出口业务"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["isMobile"])
  },
  created() {}
};
</script>

<style lang="scss">
@import "@/assets/scss/pages/about.scss";
</style>